//Función para obtener el total de items con base a una propiedad
export const getQuantityItems = (array = [], status = '') => {
    const quantity = array.filter(item => item?.status === status).length
    return quantity
}

//Función para poder filtrar un array donde se pasa un array auxiliar para verificar si la propieda el item existe en el array auxiliar
export const filterItems = (array = [], keys = []) => {
    return array.filter(column => keys.includes(column?.key))
}